<template>
<div class="content-row content" v-if="row">
    <div :class="['columns', {'is-mobile': !is_mobile}]" v-if="row.title">
        <div :class="'column is-' + row.grid"><h2 class="title is-marginless is-5">{{row.title}}</h2></div>
    </div>
    <div :class="['columns is-variable is-4', {'is-mobile': !is_mobile}]">
        <RowColumn :item="item" :key="i" v-for="item, i in row.columns" :class="item.grid ? 'is-' + item.grid : null" />
    </div>
</div>
</template>

<script>
import RowColumn from './RowColumn';
export default {
    name        :   'ContentRow',
    props       :   ['row', 'is_mobile'],
    components  :   { RowColumn }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/ContentRow.vue